import { createSlice } from "@reduxjs/toolkit";
import globalState from "redux/globalState";

export const stateSlice = createSlice({
  name: "state",
  initialState: globalState,
  reducers: {
    appendQueue: (state, action) => {
      state.queue.push(action.payload);
    },
    clearQueue: (state, action) => {
      for(let i = 0; i < state.queue.length; i++) {
        if(state.queue[i].payload === action.payload) {
          state.queue.splice(i, 1);
          break;
        }
      }
    },
    setLiquiditySources: (state, action) => {
      state.liquiditySources = action.payload
    },
    setTradeHistory: (state, action) => {
      state.tradeHistory = action.payload
    },
    serumMarkets: (state, action) => {
      state.serumMarkets = action.payload;
    },
    setMarkets: (state, action) => {
      state.markets = action.payload;
    },
    tokenList: (state, action) => {
      state.tokenList = {tokens: action.payload};
    },
    walletConnected: (state, action) => {
      state.walletConnected = true;
      state.publicKey = action.payload;
    },
    walletDisconnected: (state) => {
      state.walletConnected = false
    },
    prismBalance: (state, action) => {
      state.prismBalance = action.payload;
    },
    setProvider: (state, action) => {
      state.provider = action.payload;
    },
    initWallet: (state, action) => {
      state.wallet = action.payload;
    },
    nextUpdate: (state, action) => {
      state.nextUpdate = action.payload;
    },
    accounts: (state, action) => {
      state.accounts = action.payload;
    },
    setOpenOrders: (state, action) => {
      state.openOrders = action.payload;
    },
    newTx: (state, action) => {
      state.newTx= action.payload;
    },
    closedOpenOrders: (state, action) => {
      state.closedOpenOrders = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload
    } 
  }
});

// Action creators are generated for each case reducer function
export const { appendQueue, clearQueue, setLiquiditySources, setTradeHistory, serumMarkets, setMarkets, tokenList, 
  walletConnected, walletDisconnected, prismBalance, setProvider, initWallet, nextUpdate, accounts, setOpenOrders, newTx, closedOpenOrders,
  setTheme } = stateSlice.actions;

export default stateSlice.reducer;
